class FilterDrawer extends HTMLElement {
  connectedCallback() {
    const toggle = document.querySelector('[data-filter-drawer-toggle]');
    const closeBtn = this.querySelector('[data-filter-drawer-close]');
    const backdrop = this.querySelector('[data-filter-drawer-backdrop]');

    if (toggle) {
      this.lastToggle = toggle;
      toggle.addEventListener('click', () => this.open());
    }
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (backdrop) backdrop.addEventListener('click', () => this.close());

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key === 'Tab' && this.classList.contains('is-open')) {
        const focusable = Array.from(this.querySelectorAll('a, button, input')).filter((el) => !el.hidden && !el.disabled);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  open() {
    this.hidden = false;
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const focusable = this.querySelector('a, button, input');
    if (focusable) focusable.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    if (this.lastToggle) this.lastToggle.focus();
  }
}

customElements.define('filter-drawer', FilterDrawer);
